import type { UseFormReturnType } from '@mantine/form';
import { useEffect } from 'react';
import type { UseMutationResult } from 'react-query';
import type { ApiResponse } from '../../../util/types/Response';

export function useServerProductValidation(
	mutation: UseMutationResult<
		ApiResponse<any>,
		unknown,
		void,
		unknown
	>,
	form: UseFormReturnType<any, (values: any) => any>,
) {
	useEffect(() => {
		if (!mutation.data?.isValid) {
			// biome-ignore lint/complexity/noForEach: <explanation>
			mutation.data?.validationMessages.forEach((v) => {
				if (v.inputIdentifier === 'Skuid') {
					form.setErrors({ skuid: v.validationMessage });
				}
			});
		}
	}, [mutation.data?.validationMessages]);
}
